const STORAGE_KEY = "cdr_staging_basket_v1";
const CHANGE_EVENT = "cdr-staging-change";

export const CDR_STAGING_CHANGE_EVENT = CHANGE_EVENT;

const safeParse = (raw) => {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const normalizeCdrStagingRecord = (record, { publicRecordingUrl = "" } = {}) => {
  if (!record || record.id == null) return null;
  const internalRecording = String(record.recording || record.recording_url || "").trim();
  if (!internalRecording) return null;
  const publicUrl = String(publicRecordingUrl || record.public_recording_url || "").trim();
  return {
    id: Number(record.id),
    tarih: record.tarih || record.call_date || "",
    yon: record.yon ?? null,
    agent_name: record.agent_name || "",
    agentId: record.agentId ?? record.agent_id ?? null,
    company_name: record.company_name || "",
    arayan_numara: record.arayan_numara || "",
    aranan_numara: record.aranan_numara || "",
    konusma_suresi: record.konusma_suresi ?? 0,
    durum: record.durum ?? null,
    durum_aciklama: record.durum_aciklama || "",
    recording: publicUrl || internalRecording,
    recording_internal: internalRecording,
    public_recording_url: publicUrl || "",
    sistem: record.sistem ?? null,
    device_id: record.device_id || "",
    did: record.did || "",
    stagedAt: Date.now(),
  };
};

export const formatCdrStagingText = (record) => {
  const r = normalizeCdrStagingRecord(record);
  if (!r) return "";
  const yonLabel = r.yon === 1 ? "Gelen" : r.yon === 2 ? "Giden" : "-";
  const lines = [
    `CDR #${r.id}`,
    `Tarih: ${r.tarih || "-"}`,
    `Yön: ${yonLabel}`,
    `Agent: ${r.agent_name || "-"}`,
    `Firma: ${r.company_name || "-"}`,
    `Arayan: ${r.arayan_numara || "-"}`,
    `Aranan: ${r.aranan_numara || "-"}`,
    `Süre (sn): ${r.konusma_suresi ?? "-"}`,
    `Durum: ${r.durum_aciklama || r.durum || "-"}`,
    `Cihaz ID: ${r.device_id || "-"}`,
    `Departman: ${r.did || "-"}`,
    `Ses kaydı URL: ${r.recording || "-"}`,
  ];
  return lines.join("\n");
};

export const loadCdrStagingItems = () => {
  if (typeof window === "undefined") return [];
  return safeParse(sessionStorage.getItem(STORAGE_KEY));
};

const saveCdrStagingItems = (items) => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { items } }));
};

export const addCdrToStaging = (record, { publicRecordingUrl = "" } = {}) => {
  const normalized = normalizeCdrStagingRecord(record, { publicRecordingUrl });
  if (!normalized) return { ok: false, reason: "invalid" };

  const items = loadCdrStagingItems().filter((item) => Number(item.id) !== normalized.id);
  items.unshift(normalized);
  const trimmed = items.slice(0, 50);
  saveCdrStagingItems(trimmed);
  return { ok: true, items: trimmed, added: normalized };
};

export const removeCdrFromStaging = (id) => {
  const items = loadCdrStagingItems().filter((item) => Number(item.id) !== Number(id));
  saveCdrStagingItems(items);
  return items;
};

export const clearCdrStaging = () => {
  saveCdrStagingItems([]);
  return [];
};
